import { useEffect } from "react";

const useUsernameInput = () => {
  useEffect(() => {
    const handleInput = (e) => {
      const input = e.target;

      if (!input.classList.contains("only-username")) return;

      // ✅ Allow only a-z, A-Z, 0-9 and _
      let value = input.value.replace(/[^a-zA-Z0-9_]/g, "");

      const maxLength = input.getAttribute("data-maxlength");
      if (maxLength) {
        value = value.slice(0, parseInt(maxLength));
      }

      input.value = value;
    };

    document.addEventListener("input", handleInput);
    return () => document.removeEventListener("input", handleInput);
  }, []);
};

export default useUsernameInput;
